module.exports = __webpack_public_path__ + "static/media/bike2go.4754ea00.jpg";